import PropTypes from 'prop-types'
import React, { useContext, useEffect } from 'react'
import Button from '@react/react-spectrum/Button'
import Heading from '@react/react-spectrum/Heading'
import Well from '@react/react-spectrum/Well'
import { success } from '@react/react-spectrum/Toast'
import { Card, CardCoverPhoto, CardBody, CardFooter } from '@react/react-spectrum/Card'

import { ProfileContext } from '../../../root/ProfileContext'
import { ScannerContext } from '../../../root/ScannerContext'
import { RootContext } from '../../../root/RootContext'

import LocaleCurrency from 'locale-currency'
import getSymbolFromCurrency from 'currency-symbol-map'

import './Kiosk.scss'

export default function Kiosk({ meta, content }) {
  const profileContext = useContext(ProfileContext)
  const currentProfile = profileContext.state.currentProfile

  const rootContext = useContext(RootContext)
  const scannerContext = useContext(ScannerContext)

  const product = scannerContext.state.currentProduct

  const locale = rootContext.project.meta.locale
  const currencyCode = LocaleCurrency.getCurrency(locale)
  const currencySymbol = getSymbolFromCurrency(currencyCode)

  useEffect(() => {
    if (currentProfile) {
    }
  }, [currentProfile])

  /*
  const handleChange = (k, e) => {
    setValues({ ...values, [k]: e })
  }
*/

  return (
    <div className='profile-module kiosk'>
      <div className='module-content'>
        {currentProfile && <div align='center'>{content.description && <Well>{content.description}</Well>}</div>}
      </div>

      <div align='center'>
        {currentProfile && product && (
          <Card allowsSelection={false} className='product'>
            <CardCoverPhoto src={product.imageURL} />
            <CardBody
              title={product.name}
              subtitle={`${product.priceTotal}  ${currencySymbol}`}
              description={`reference # ${product.SKU}`}
            />
            <CardFooter>
              <span className={'cardFooter-left'}></span>
              <span className={'cardFooter-right'}>
                <Button
                  name='kioskOk'
                  data-channel='kiosk'
                  variant='primary'
                  onClick={(e) => {
                    e.preventDefault()
                    e.target.dispatchEvent(
                      new CustomEvent('kioskOk', {
                        detail: {
                          channel: 'kiosk',
                          content: product,
                        },
                      })
                    )
                    success('Product successfully collected', {
                      onClose: () => {},
                      timeout: 4000,
                    })
                  }}
                >
                  Confirm
                </Button>
              </span>
            </CardFooter>
          </Card>
        )}
      </div>
    </div>
  )
}

Kiosk.requiresLaunch = true
